import { PageNavParams } from "@web-src/modules/navigation/types";
import { ModulePagesConfig } from "@web-src/modules/navigation/types/ModulePagesConfigs";
import { UserRole } from "@jugl-web/rest-api";
import { CXAIAgentsPage } from "./CXAIAgentsPage/CXAIAgentsPage";
import { CXAnalyticsPage } from "./CXAnalyticsPage/CXAnalyticsPage";
import { CXWorkspaceGeneralPage } from "./CXWorkspaceGeneralPage";
import { CXWorkspacePlansPage } from "./CXWorkspacePlansPage";
import { CXTrialPage } from "./CXTrialPage";
import { CXWorkspaceTeamMembersPage } from "./CXWorkspaceTeamMembersPage";
import { CXLoginPage } from "./CXLoginPage";
import { CXOnboardingPage } from "./CXOnboardingPage";
import { CXActionsPage } from "./CXActionsPage";
import { CXActionsFormPage } from "./CXActionsFormPage";

export type CXPagesNavigationParams = {
  cxTrial: PageNavParams;
  cxAIAgents: PageNavParams;
  cxAnonymousAIAgents: PageNavParams;
  cxAnalytics: PageNavParams;
  cxWorkspaceGeneral: PageNavParams;
  cxWorkspacePlans: PageNavParams;
  cxWorkspaceTeamMembers: PageNavParams;
  cxLogin: PageNavParams;
  cxOnboarding: PageNavParams<never, { flow?: string }>;
  cxActions: PageNavParams;
  cxActionsForm: PageNavParams;
};

export const cxPagesNavigationConfig: ModulePagesConfig<CXPagesNavigationParams> =
  {
    cxTrial: {
      element: <CXTrialPage />,
      path: "cx/trial",
      isEntityOptional: true,
      isPrivate: true,
      isAnonymousAllowed: true,
      isNavigationHidden: true,
      isSideBarHidden: true,
    },
    cxAnonymousAIAgents: {
      element: <CXAIAgentsPage />,
      path: "cx/anonymous/ai-agents",
      isPrivate: true,
      isAnonymousAllowed: true,
    },
    cxAIAgents: {
      element: <CXAIAgentsPage />,
      path: "cx/ai-agents",
      isPrivate: true,
    },
    cxAnalytics: {
      element: <CXAnalyticsPage />,
      path: "cx/analytics",
      isPrivate: true,
    },
    cxActions: {
      element: <CXActionsPage />,
      path: "cx/actions",
      isPrivate: true,
    },
    cxActionsForm: {
      element: <CXActionsFormPage />,
      path: "cx/actions/form",
      isPrivate: true,
    },
    cxWorkspaceGeneral: {
      element: <CXWorkspaceGeneralPage />,
      path: "cx/workspace-admin/general",
      isPrivate: true,
      isSideBarHidden: true,
      requiredUserRoles: [UserRole.admin],
    },
    cxWorkspacePlans: {
      element: <CXWorkspacePlansPage />,
      path: "cx/workspace-admin/plans",
      isPrivate: true,
      isSideBarHidden: true,
      requiredUserRoles: [UserRole.admin],
    },
    cxWorkspaceTeamMembers: {
      element: <CXWorkspaceTeamMembersPage />,
      path: "cx/workspace-admin/team-members",
      isPrivate: true,
      isSideBarHidden: true,
      requiredUserRoles: [UserRole.admin],
    },
    cxLogin: {
      element: <CXLoginPage />,
      path: "/cx/login",
      isPrivate: false,
      isNavigationHidden: true,
      isSideBarHidden: true,
    },
    cxOnboarding: {
      element: <CXOnboardingPage />,
      path: "/cx/onboarding",
      isPrivate: true,
      isEntityOptional: true,
      isProfileOptional: true,
      isNavigationHidden: true,
      isSideBarHidden: true,
    },
  };
